import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";

export class EvenOddBetsPanel extends ObservableContainer {

    private buttons: Array<Button> = [];

    private readonly EVEN_NUMBERS: Array<number> = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36];
    private readonly ODD_NUMBERS: Array<number> = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35];

    constructor(evenButtonPositionX: number,
                oddButtonPositionX: number,
                evenOddButtonsPositionY: number) {
        super();
        this.createAndAddEvenBetButton(evenButtonPositionX, evenOddButtonsPositionY);
        this.createAndAddOddBetButton(oddButtonPositionX, evenOddButtonsPositionY);
    }

    public getButtonPosition(lowNumbers: boolean): PIXI.Point {
        if (lowNumbers) {
            return (this.buttons[0].position as PIXI.Point);
        } else {
            return (this.buttons[1].position as PIXI.Point);
        }
    }

    private onValueChosen(evenNumbersSelected: boolean): void {
        if (evenNumbersSelected) {
            this.callOnClickedSubscribers(evenNumbersSelected, this.EVEN_NUMBERS);
        } else {
            this.callOnClickedSubscribers(evenNumbersSelected, this.ODD_NUMBERS);
        }
    }

    private onHover(evenNumbersSelected: boolean): void {
        if (evenNumbersSelected) {
            this.callOnPointerDownSubscribers(evenNumbersSelected, this.EVEN_NUMBERS);
        } else {
            this.callOnPointerDownSubscribers(evenNumbersSelected, this.ODD_NUMBERS);
        }
    }

    private onHoverOutside(evenNumbersSelected: boolean): void {
        if (evenNumbersSelected) {
            this.callOnPointerUpSubscribers(evenNumbersSelected, this.EVEN_NUMBERS);
        } else {
            this.callOnPointerUpSubscribers(evenNumbersSelected, this.ODD_NUMBERS);
        }
    }

    private createAndAddEvenBetButton(positionX: number, positionY: number): void {
        const button = new Button(data.images.colorEvenLowBaseState, data.images.colorEvenLowHoverDisableState,
            data.images.colorEvenLowHoverDisableState, data.images.colorEvenLowHoverDisableState);

        this.initializeBetButtonBehavior(button, true);
        button.position.x = positionX;
        button.position.y = positionY;
        this.buttons.push(button);
        this.addChild(button);
    }

    private createAndAddOddBetButton(positionX: number, positionY: number): void {
        const button = new Button(data.images.colorEvenLowBaseState, data.images.colorEvenLowHoverDisableState,
            data.images.colorEvenLowHoverDisableState, data.images.colorEvenLowHoverDisableState);

        this.initializeBetButtonBehavior(button, false);
        button.position.x = positionX;
        button.position.y = positionY;
        this.buttons.push(button);
        this.addChild(button);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/EvenOddBetsPanel.ts